import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChatService } from '../services';
import { filter } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';

@Component({
  templateUrl: './chat-favourites.component.html',
  styles: [
    `
      .titlestyle {
        color: #0000ee;
      }

      .titlestyle:hover {
        color: #0056b3;
        text-decoration: underline;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatFavouritesComponent {
  private favouriteCount: number = 0;

  rooms$ = this.chatSvc.rooms$;

  constructor(
    public activeModal: NgbActiveModal,
    private chatSvc: ChatService,
    private toastSvc: ToastrService
  ) {
    this.chatSvc.favourites$
      .pipe(filter((favourites) => favourites !== undefined))
      .subscribe((favourites) => {
        this.favouriteCount = favourites!.length;
      });
  }

  closeAndRefresh() {
    this.chatSvc.refreshRooms();
    this.activeModal.close('Cross click');
  }

  toggleAllchat(chatroom: string) {
    this.chatSvc.toggleAllChat(chatroom);
  }

  toggleFavourite(chatroom: string, e: Event) {
    if (!(e.target as HTMLInputElement).checked || this.favouriteCount < 30) {
      this.chatSvc.toggleFavourite(chatroom);
      return true;
    } else {
      this.toastSvc.error('You can only have a maximum of 30 favourites.');
      return false;
    }
  }

  uncheckAllChat() {
    this.chatSvc
      .confirm(
        'Remove All Chat',
        'Are you sure you wish to open a remove all the All Chat chatrooms?'
      )
      .then((confirmresult) => {
        if (confirmresult) {
          this.chatSvc.clearAllChat();
        }
      });
  }

  uncheckFavourites() {
    this.chatSvc
      .confirm(
        'Remove Favourites',
        'Are you sure you wish to open a remove all the Favourite chatrooms?'
      )
      .then((confirmresult) => {
        if (confirmresult) {
          this.chatSvc.clearFavourites();
        }
      });
  }
}
